<template>
  <div class="mx-auto p-3 mb-4 border">
    <p>
      Wenn es besonders schnell und anonym gehen soll, so haben Sie die
      Möglichkeit unkompliziert über Ihr Handy, bzw. Mobiltelefon zu bezahlen.
    </p>
    <p>
      Die Telefonanbieter erheben für uns leider hohe Gebühren bei dieser
      Bezahlungsmethode, daher bekommen Sie verhältnismäßig weniger
      {{ appCurrency }} als mit anderen Bezahlmehoden.
    </p>
    <span>
      Diese Zahlungsmethode ist nur über ein Handy / Mobiltelefon möglich.
    </span>
  </div>
</template>

<script>
export default {
  computed: {
    appCurrency() {
      return Laravel.lang.currency;
    }
  }
};
</script>
